import { render, staticRenderFns } from "./operations-add-or-update.vue?vue&type=template&id=0487141f&scoped=true&"
import script from "./operations-add-or-update.vue?vue&type=script&lang=js&"
export * from "./operations-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./operations-add-or-update.vue?vue&type=style&index=0&id=0487141f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487141f",
  null
  
)

export default component.exports